var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from 'ember-data-model-fragments/fragment';
import Enum from '@square/dashboard-utilities/utils/enum';
import { inject as service } from '@ember/service';
export const Cadence = new Enum(['MONTH', 'YEAR']);
let CadenceCost = (_dec = attr('enum', {
  enumClass: Cadence
}), _dec2 = fragment('price-money'), _class = class CadenceCost extends EmberDataBaseFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "cadence", _descriptor2, this);
    _initializerDefineProperty(this, "cost", _descriptor3, this);
  }
  get toString() {
    switch (this.cadence) {
      case Cadence.MONTH:
        return this.i18n.t('subscriptions.saas.domains.priceCadence.month', {
          price: this.cost.formatted
        });
      case Cadence.YEAR:
        return this.i18n.t('subscriptions.saas.domains.priceCadence.year', {
          price: this.cost.formatted
        });
      default:
        break;
    }
    return '';
  }
  get toBilledString() {
    switch (this.cadence) {
      case Cadence.MONTH:
        return this.i18n.t('subscriptions.saas.domains.billedPriceCadence.month', {
          price: this.cost.formatted
        });
      case Cadence.YEAR:
        // This case is never displayed to the user.
        break;
      default:
        break;
    }
    return '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cadence", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cost", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CadenceCost as default };